import React, { useState, useEffect, useContext } from 'react';
import styles from './styles.module.css';

import { Context } from '../../context/UserContext';

import PrevCard from '../PrevCard';
import Modal from '../Modal';
import CardNotes from '../CardNotes';
import ConfirmDeleteModal from '../ConfirmDeleteModal';

function RecentNotes() {

  const { getMyInvoices, user, setUser, deleteInvoice, invoices, setInvoices } = useContext(Context);

  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);

  const [visibleCount, setVisibleCount] = useState(3);

  const token = JSON.parse(localStorage.getItem('token')) || '';

  useEffect(() => {
    async function fetchInvoices() {
      const data = await getMyInvoices(token);
      setInvoices(data);
    }

    fetchInvoices();

  }, [token]);

  function handleDelete(id){
    setInvoiceToDelete(id);
    setShowDeleteModal(true);
  }

  async function confirmDelete(){

    if(!invoiceToDelete) return;

    await deleteInvoice(invoiceToDelete, token);

    setInvoices(prev =>
      prev.filter(invoice => invoice._id !== invoiceToDelete)
    );

    setShowDeleteModal(false);
    setInvoiceToDelete(null);
  }

  function openDetails(invoice){
    setSelectedInvoice(invoice);
    setShowDetails(true);
  }

  const sortedInvoices = [...invoices].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const visibleInvoices = sortedInvoices.slice(0, visibleCount);

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 3);
  };

  const handleShowLess = () => {
    setVisibleCount(3);
  };

  return (
    <>
      <section className={styles.container}>

        <div className={styles.header}>
          <h3>Notas Recentes</h3>
        </div>

        {visibleInvoices.length > 0 ? (
          <div className={styles.notesList}>

            {visibleInvoices.map((invoice) => (
              <PrevCard
                key={invoice._id}
                invoice={invoice}
                onClick={() => openDetails(invoice)}
                onDelete={handleDelete}
              />
            ))}

          </div>
        ) : (
          <p className={styles.emptyState}>Você ainda não possui notas.</p>
        )}

        <div className={styles.buttonsWrapper}>

          {visibleCount < sortedInvoices.length && (
            <button onClick={handleShowMore} className={styles.showMoreBtn}>
              Ver mais
            </button>
          )}

          {visibleCount > 3 && (
            <button onClick={handleShowLess} className={styles.showLessBtn}>
              Ver menos
            </button>
          )}

        </div>

        {showDetails && selectedInvoice && (
          <Modal
            createdInvoice={selectedInvoice}
            setShowModal={setShowDetails}
            setCreatedInvoice={setSelectedInvoice}
            user={user}
            setUser={setUser}
          >
            <CardNotes createdInvoice={selectedInvoice}/>
          </Modal>
        )}

      </section>

      {showDeleteModal && (
        <ConfirmDeleteModal
          onConfirm={confirmDelete}
          onCancel={() => setShowDeleteModal(false)}
        />
      )}

    </>
  );
}

export default RecentNotes;